module.exports = __webpack_public_path__ + "./assets/2-47ac47.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/2.bmp
// module id = 20
// module chunks = 0